import { useState } from 'react'
import { markPending, pendingMarkLabel } from '@kronos/domain'
import type { Marking } from '@kronos/domain'
import type { ItemUnit } from '../../data/inventory'
import { Badge } from '../primitives'
import { Link } from '../shell/Link'
import { whenText, whereText } from './shared'

/**
 * Every unit of a serialized item: our number, the maker's, and where it is.
 * Each row is one button to the component's page, with a chevron saying so.
 * The latest ten first — sixty cameras is a page to scroll past, not to read.
 */
const FIRST = 10

export function ItemUnits({
  units,
  marking,
  total,
}: {
  units: readonly ItemUnit[]
  marking: Marking
  total: number
}): JSX.Element {
  const [all, setAll] = useState(false)
  const shown = all ? units : units.slice(0, FIRST)
  const pending = pendingMarkLabel(marking)

  return (
    <>
      <div className="panel">
        <div className="inv-units-head" aria-hidden="true">
          <span>Kronos serial</span>
          <span>Maker’s serial</span>
          <span>Where</span>
          <span>Received</span>
        </div>
        <div className="row-list">
          {shown.map((u) => (
            <Link key={u.componentId} to={{ name: 'component', id: u.componentId }} className="row-item inv-unit-row">
              <span className="inv-unit-row__serial">
                <span className="serial row-item__title">{u.serial}</span>
                {pending && u.location !== 'scrapped' && markPending(marking, u.printed) ? <Badge tone="info">{pending}</Badge> : null}
              </span>
              <span className={`inv-unit-row__maker ${u.makerSerial ? 'serial' : 'muted'}`}>
                {u.makerSerial ? <span className="inv-unit-row__phone">maker </span> : null}
                {u.makerSerial ?? '—'}
              </span>
              <span className="inv-unit-row__where">{whereText(u)}</span>
              <span className="inv-unit-row__when muted">{whenText(u.receivedAt)}</span>
            </Link>
          ))}
        </div>
      </div>
      {!all && units.length > FIRST ? (
        <button type="button" className="inv-more" onClick={() => setAll(true)}>
          Show all {units.length} units
        </button>
      ) : null}
      {total > units.length ? (
        <p className="muted inv-quiet">Showing the latest {units.length} of {total}.</p>
      ) : null}
    </>
  )
}
